<template>
  <div>
    <CRow>
      <CCol xs="12" sm="6" md="6" lg="6" xl="2">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker id="datepicker" locale="vi" v-model="dateRange" :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }"
            is-range class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input :value="inputValue.start + ' - ' + inputValue.end" v-on="inputEvents.start"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300" readonly />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT')">
        <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data" ref="districtCodeInput">
        </BaseSelect>
      </CCol>
      <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT') || $hasAuthor('ROLE_DISTRICT')">
        <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
      </CCol>
      <!-- <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="$hasAuthor('ROLE_ADMIN')">
        <BaseSelect :options="deviceInput.options" :data="deviceInput.data" ref="deviceInput"></BaseSelect>
      </CCol> -->
      <CCol xs="12" sm="6" md="6" lg="6" xl="2">
        <BaseInput :options="titleInput.options" :data="titleInput.data" />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton style="float: right; margin-left: 5px; margin-top: 1px;" color="primary"
              v-c-tooltip.hover="'Tải lại'" class="btn-action-primary" @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
            <CButton style="float: right; ; margin-top: 1px;" color="primary" v-c-tooltip.hover="'Thêm mới'"
              class="btn-action-primary" @click="$router.push('/radio-activities/schedule-add.html')">
              <i class="fa fa-plus"></i>&nbsp;Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
          ref="mainTable">
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #createDate="{ item }">
            <td>
              <div style="font-weight: bold;" v-c-tooltip.hover="{ content: 'Người tạo lịch', placement: 'right' }">
                {{ item.createUserName }}
              </div>
              <div v-c-tooltip.hover="{ content: 'Thời gian tạo lịch', placement: 'right' }">
                {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
              </div>
            </td>
          </template>
          <template #fromDate="{ item }">
            <td>
              <!-- <span v-if="item.mode == 3">
                {{ $helper.formatDate(item.fromDate) }}
              </span>
              <span v-else>
                {{ $helper.formatDateDDMMYYYY(item.fromDate) }}
              </span> -->
              {{ $helper.formatDateDDMMYYYY(item.fromDate) }}
            </td>
          </template>
          <template #toDate="{ item }">
            <td>
              <!-- <span v-if="item.mode == 3">
                {{ $helper.formatDate(item.toDate) }}
              </span>
              <span v-else>
                {{ $helper.formatDateDDMMYYYY(item.toDate) }}
              </span> -->
              {{ $helper.formatDateDDMMYYYY(item.toDate) }}
            </td>
          </template>
          <!-- <template #fileTitle="{ item }">
            <td style="font-weight: bold; cursor: pointer">
              <template v-if="item.mode != 3">
                <span v-if="item.fileTitle != null && item.fileTitle != ''" v-c-tooltip.hover="{ content: 'Ấn để nghe' }"
                  @click="previewFile(item.fileTitle, item.fileUrl)">
                  {{ item.fileTitle }}
                </span>
                <span v-else-if="item.channelDigitalName != null && item.channelDigitalName != ''"
                  v-c-tooltip.hover="{ content: 'Ấn để nghe' }"
                  @click="previewFile(item.channelDigitalName, item.channelDigitalUrl)">
                  {{ item.channelDigitalName }}
                </span>
                <span v-else-if="item.playListId != null && item.playListTitle != ''"
                  v-c-tooltip.hover="{ content: 'Ấn để nghe' }"
                  @click="previewFile(item.playListTitle, '', item.playListId)">
                  {{ item.playListTitle }}
                </span>
              </template>
              <template v-else>
                <span v-if="item.toDate != ''" v-c-tooltip.hover="{ content: 'Ấn để nghe' }"
                  @click="previewFile(item.title, item.url)">{{
                    item.title
                  }}</span>
                <span v-else>{{
                  item.title
                }}</span>
              </template>
            </td>
          </template> -->
          <!-- <template #devices="{ item, index }">
            <td>
              <span class="badge badge-light mr-2" v-for="(each) in viewDevice(item)">
                {{ each }}
              </span>
              <span style="cursor: pointer;" class="badge badge-light"
                v-show="$helper.convertStringToArray(item.devices, ';\n').length > item.maxDisplayDeviceTable"
                @click="showMoreDevice(item, index)">Xem thêm ...</span>
              <span style="cursor: pointer;" class="badge badge-light"
                v-show="$helper.convertStringToArray(item.devices, ';\n').length > defaultMaxDisplayDeviceTable && item.maxDisplayDeviceTable > defaultMaxDisplayDeviceTable"
                @click="hideMoreDevice(item, index)">Ẩn bớt ...</span>
            </td>
          </template> -->
          <template #locations="{ item, index }">
            <td>
              <span class="badge badge-light mr-2" v-for="(each) in viewDevice(item)">
                {{ each }}
              </span>
              <span style="cursor: pointer;" class="badge badge-light"
                v-show="$helper.convertStringToArray(item.locations, ';\n').length > item.maxDisplayDeviceTable"
                @click="showMoreDevice(item, index)">Xem thêm ...</span>
              <span style="cursor: pointer;" class="badge badge-light"
                v-show="$helper.convertStringToArray(item.locations, ';\n').length > defaultMaxDisplayDeviceTable && item.maxDisplayDeviceTable > defaultMaxDisplayDeviceTable"
                @click="hideMoreDevice(item, index)">Ẩn bớt ...</span>
            </td>
          </template>
          <template #mode="{ item }">
            <td>
              <span class="badge badge-light" v-if="item.mode == 0">Khung giờ cố định</span>
              <span class="badge badge-light" style="font-weight:bold" v-else-if="item.mode == 1">Theo lịch thiết lập
                <br>
                ({{
                  item.modeSchedule == 0 ? 'Ngày trong tuần' : 'Ngày trong tháng'
                }})</span>
              <span class="badge badge-danger" v-else-if="item.mode == 2">Khẩn cấp</span>
              <span class="badge badge-primary" v-else-if="item.mode == 3">Phát trực tiếp</span>
            </td>
          </template>
          <template #active="{ item }">
            <td>
              <span v-if="item.active == true" class="dot-custom dot-success">
                Hoạt động
                <!-- <BaseSwitch class="mx-1" color="success" checked variant="3d" v-c-tooltip.hover="'Hủy'" v-bind="labelIcon"
                  @update:checked="setupSelectOneAction('update_active', item.id, item.active, item.fromDate, item.toDate)" /> -->
              </span>
              <span v-else class="dot-custom dot-danger">
                Đã hủy
                <!-- <BaseSwitch class="mx-1" color="danger" variant="3d" v-c-tooltip.hover="'Kích hoạt'" v-bind="labelIcon"
                  @update:checked="setupSelectOneAction('update_active', item.id, item.active, item.fromDate, item.toDate)" /> -->
              </span>
            </td>
          </template>
          <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <!-- <a v-if="item.mode != 3"
                class="a btn-sm btn btn-outline-info"  :href="`/schedule-management/${item.id}/managed-shedule-detail.html`"
                  v-c-tooltip.hover="'Xem chi tiết'">
                  <i class="fa fa-eye"></i>
                </a> -->
                <CButton color="info" variant="outline" v-c-tooltip.hover="'Xem chi tiết'" square size="sm"
                  @click="viewDetail($event, item)">
                  <i class="fa fa-eye"></i>
                </CButton>
                <CButton v-if="item.mode == 0 || item.mode == 1" color="danger" variant="outline" v-c-tooltip.hover="'Hủy lịch'" square size="sm" @click="cancelSchedule($event, item)">
                  <CIcon name="cil-x" />
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>

    <CModal title="Hủy lịch phát" :show.sync="cancelModal.isShowCancelModel" :closeOnBackdrop="false" :size="'lg'">
      <CCardBody>
        <BaseTable :options="cancelTable.options" :slots="cancelTable.slots" :dataSource="cancelTable.dataSource" @row-click="rowClickTableCancel($event)"
          ref="cancelTable">
          <template #checkbox="{ item }">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" v-model="cancelModal.lstLocationSelected"
                  :value="item.locationCode" :id="item.locationCode" />
                <label class="custom-control-label" :for="item.locationCode"></label>
              </div>
            </td>
          </template>
          <template #index="{ index }">
            <td>{{ $refs.cancelTable.getTotalElementByPage + index }}</td>
          </template>
        </BaseTable>
      </CCardBody>
      <!-- </CRow> -->
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="cancelModal.isShowCancelModel = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitCancel()"><i
            class="fa fa-check"></i> Xác nhận
        </button>
      </template>
    </CModal>

    <CModal title="Lịch phát đã tồn tại" :show.sync="exist.isShowModelExist" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol xs="12" md="12" lg="12" xl="12">
          Đã tồn tại lịch phát ngày <span style="font-weight:bold">{{ exist.playDate }}</span>
          khung giờ <span style="font-weight:bold">{{ exist.startTime + ' - ' + exist.endTime }}</span>
          với các thiết bị:
          <span v-for="i of exist.devices">
            <br />
            {{ '- ' + i }}
          </span>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="exist.isShowModelExist = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="$router.push(`${exist.id}/managed-schedule-detail.html`)">
          <i class="fa fa-eye"></i> Xem lịch
          đã tồn tại
        </button>
      </template>
    </CModal>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>
    <BaseFormPreview v-if="previewModel.isShowModal" :title="previewModel.title" :url="previewModel.url"
      :playListId="previewModel.playListId" @close-modal="previewModel.isShowModal = false"></BaseFormPreview>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import { DatePicker } from "v-calendar";
import { USER_NAME } from '../../constant';
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseModal from "@/views/base/BaseModal";
import BaseInput from "@/views/base/BaseInput";
import BaseFormPreview from "@/views/base/BaseFormPreview";

export default {
  name: "ScheduleList",
  components: {
    BaseFormPreview,
    BaseInput,
    BaseModal,
    BaseSelect,
    BaseFormLoading,
    BaseTable,
    DatePicker,
    ModalConfirm,
    BaseSwitch
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;

    let actionTypeMapping = new Map();

    actionTypeMapping.set("update_active", {
      url: "/schedule/update-active",
      titlePopup: function () {
        return that.$helper.setupTitleAction("hủy toàn bộ lịch", 'từ ngày'
          , that.$helper.formatDateDDMMYYYY(that.actionData.model.fromDate) + ' đến ngày '
          + that.$helper.formatDateDDMMYYYY(that.actionData.model.toDate))
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.id
        };
      },
      successCallback: function (response) {
        if (response.data && response.data.id) {
          that.exist.id = response.data.id;
          that.exist.msg = response.data.msg;
          that.exist.startTime = response.data.startTime;
          that.exist.endTime = response.data.endTime;
          that.exist.playDate = response.data.playDate;
          that.exist.devices = response.data.devices;
          that.exist.isShowModelExist = true;
        } else {
          that.showSuccessMsg({ message: that.actionData.model.active == true ? "Hủy lịch thành công" : "Kích hoạt lịch thành công" });
          that.loadDataMainTable();
        }
      },
      errorCallback: function (error) {
        console.log(error)
        that.$helper.handleError(that.$router, error);
      },
    });

    return {
      loading: { value: false },
      loadingPreview: { value: false },
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      cancelModal: {
        isShowCancelModel: false,
        scheduleCancelId: null,
        lstLocationSelected: [],
        selectedAll: false
      },
      exist: {
        id: "",
        msg: "",
        playDate: "",
        startTime: "",
        endTime: "",
        devices: [],
        isShowModelExist: false
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          id: null,
          active: null,
          fromDate: null,
          toDate: null
        }
      },
      previewModel: {
        isShowModal: false,
        title: '',
        url: '',
        playListId: ''
      },
      dateRange: {
        start: this.$helper.subtractNowDate(3),
        end: this.$helper.plusDateTime(1, 'd')._d
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE') || this.$hasAuthor('ROLE_MANAGEMENT')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                level: 1
              }
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: this.$hasAuthor('ROLE_DISTRICT') ? false : true,
          // disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model,
                level: 2
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      // deviceInput: {
      //   options: {
      //     filter: true,
      //     label: "Thiết bị",
      //     selectAllText: "Tất cả thiết bị",
      //     'keyField': 'value',
      //     'valueField': 'text'
      //   },
      //   data: {
      //     name: "deviceId",
      //     model: '',
      //     items: [],
      //     source: {
      //       url: '/devices/find-all',
      //       dataSubmit: function () {
      //         return {}
      //       },
      //       isJsonContentType: false,
      //       response: function (dataResponse) {
      //         that.deviceInput.data.items = dataResponse.data;
      //       }
      //     },
      //     updateTrigger: function () {
      //       return that.$refs.mainTable;
      //     },
      //   }
      // },
      titleInput: {
        options: {
          placeholder: "Tên lịch phát",
          label: 'Tên lịch phát'
        },
        data: {
          name: "title",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      defaultMaxDisplayDeviceTable: 10,

      mainTable: {
        options: {
          fields: [
            { key: "index", label: "STT", sorter: false, filter: false },
            { key: "createDate", label: "Thông tin lịch" },
            { key: "description", label: "Tên lịch phát" },
            // { key: "fileTitle", label: "Nội dung phát" },
            { key: "fromDate", label: "Thời điểm bắt đầu" },
            { key: "toDate", label: "Thời điểm kết thúc" },
            // { key: "devices", label: "Thiết bị phát" },
            { key: "locations", label: "Địa bàn phát" },
            { key: "mode", label: "Kiểu lịch" },
            { key: "locationName", label: "Địa bàn tạo" },
            {key: "active", label: "Trạng thái", _style: "width:10%"},
            { key: "action", label: "Thao tác", sorter: false, filter: false }
          ],
          slots: [
            "index", "createDate", "fromDate", "toDate", "devices", "locations", "mode",
            "active",
            "action"
          ],
          lazyLoad: this.$hasAuthor('ROLE_WARD') || this.$hasAuthor('ROLE_VILLAGE') ? true : false,
          sorter: true,
          columnFilter: false,
          pageSize: 20,
          itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
          tableFilter: { label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true },
        },
        dataSource: {
          url: "/schedule/getPages",
          dataSubmit: function () {
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDateDDMMYYYY(that.dateRange.start);
            params.toDate = that.$helper.formatDateDDMMYYYY(that.dateRange.end);
            params.locationCode = that.locationCode.data.model;
            params.title = that.titleInput.data.model;
            // params.deviceId = that.deviceInput.data.model;
            return params;
          },
          response: function (dataResponse) {
            dataResponse.data.dataContent.content.map(each => each.maxDisplayDeviceTable = that.defaultMaxDisplayDeviceTable);
            return dataResponse.data;
          },
        },
      },
      cancelTable: {
        options: {
          fields: [
            { key: "checkbox", label: "#", sorter: false, filter: false },
            { key: "index", label: "STT", sorter: false, filter: false },
            { key: "locationName", label: "Địa bàn" }
          ],
          slots: [
            "checkbox", "index"
          ],
          lazyLoad: false,
          sorter: false,
          columnFilter: false,
          clickableRows: true,
          hover: false,
          pageSize: 10,
          itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
          tableFilter: { label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true },
        },
        dataSource: {
          url: "/schedule/page-location-schedule",
          dataSubmit: function () {
            var params = {
              scheduleId: that.cancelModal.scheduleCancelId
            };
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
      hlsPreview: '',
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.items.map(each => delete each.maxDisplayDeviceTable);
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    setupSelectOneAction: function (actionTypeKey, id, active, fromDate, toDate) {
      let actionData = this.actionData.model;
      actionData.id = id || null;
      actionData.active = active || null;
      actionData.fromDate = fromDate || null;
      actionData.toDate = toDate || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    viewDetail(event, item) {
      if (event.ctrlKey) {
        const routeData = this.$router.resolve(`${item.id}/managed-schedule-detail.html`);
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push(`${item.id}/managed-schedule-detail.html`)
      }
    },
    previewFile(title, url, playListId) {
      this.previewModel.title = title;
      this.previewModel.url = url;
      this.previewModel.playListId = playListId;
      this.previewModel.isShowModal = true;
    },
    viewDevice(item) {
      if (!item.locations) {
        return [];
      }
      var _devices = this.$helper.convertStringToArray(item.locations, ';\n');
      if (_devices.length <= this.defaultMaxDisplayDeviceTable) {
        return _devices;
      }
      return _devices.slice(0, item.maxDisplayDeviceTable);
    },
    showMoreDevice(item, index) {
      let that = this;
      var _devices = that.$helper.convertStringToArray(item.locations, ';\n');
      that.$refs.mainTable.items[index].maxDisplayDeviceTable = _devices.length;
    },
    hideMoreDevice(item, index) {
      let that = this;
      this.$refs.mainTable.items[index].maxDisplayDeviceTable = that.defaultMaxDisplayDeviceTable;
    },
    cancelSchedule(event, item) {
      let that = this;
      that.cancelModal.isShowCancelModel = true;
      that.cancelModal.scheduleCancelId = item.id;
      that.$refs.cancelTable.loadData(true);
    },
    rowClickTableCancel(value) {
      let targetClick = value.event.target;
      if (value && value.item && value.item.locationCode) {
        console.log(this.cancelModal.lstLocationSelected)
        if (this.cancelModal.lstLocationSelected.includes(value.item.locationCode)) {
          const index = this.cancelModal.lstLocationSelected.indexOf(value.item.locationCode)
          if (index > -1) {
            this.cancelModal.lstLocationSelected.splice(index, 1);
            value.item._classes = 'inactive';
          }
        } else {
          value.item._classes = 'active';
          this.cancelModal.lstLocationSelected.push(value.item.locationCode);
        }
      }
    },
    changeCancelSelectAll: function (event) {
      if (this.cancelModal.selectedAll) {
        this.cancelModal.lstLocationSelected = [];
        this.$refs.cancelTable.items.forEach(each => {
          this.cancelModal.lstLocationSelected.push(each.locationCode);
        });
      } else {
        this.cancelModal.lstLocationSelected = [];
      }
    },
    submitCancel: function () {
      let that = this;
      if(that.cancelModal.lstLocationSelected.length == 0){
        that.showErrorMsg({message: "Vui lòng chọn địa bàn để hủy lịch"});
        return;
      }
      that.$helper.loadDataSource({
        url: "/schedule/cancel-schedule-location",
        dataSubmit: function () {
          return {
            locations: that.cancelModal.lstLocationSelected,
            id: that.cancelModal.scheduleCancelId
          };
        },
        successCallback: async function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Đã gửi lệnh hủy lịch phát"});
            that.cancelModal.isShowCancelModel = false;
          }
          // that.loading.value = false
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false
        }
      });
    }
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: new Date().setHours(0, 0, 0, 0),
          end: new Date().setHours(23, 59, 59, 999)
        }
      }
    },
    'districtCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
        // this.wardCodeInput.options.disabled = false;
      } else {
        // this.wardCodeInput.data.items = [];
        // this.wardCodeInput.options.disabled = true;
      }
      this.$refs.wardCodeInput.loadData();
      this.wardCodeInput.data.model = null
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
    },
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
